import './core-hop';
import './patch-xhr';

import {mixin as compat} from './services/compat';
import {mixin as eventEmitter} from './services/event-emitter';
import {mixin as getScript} from './services/get-script';
import {mixin as logging} from './services/logging.js';
import {mixin as modules} from './services/modules';
import {mixin as pageTop} from './services/page-top';
import {mixin as gtm} from './services/gtm';
import {mixin as stringUtils} from './services/string-utils';
import {mixin as tracking} from './services/tracking';
import {mixin as utils} from './services/utils';
import {mixin as nativeTrigger} from './services/nativeTrigger';

const Hop = window.Hop;

// Alias
Hop.document = document;
Hop.window = window;
Hop.html = document.querySelector('html');
// Tag body not available at this point so defining getter instead of value
Object.defineProperty(Hop, 'body', {get: () => Hop.document.body});

// Mixins
utils(Hop);
compat(Hop);
logging(Hop);
eventEmitter(Hop);
getScript(Hop);
modules(Hop);
pageTop(Hop);
stringUtils(Hop);
gtm(Hop);
tracking(Hop);
nativeTrigger(Hop);

// Event bus
Hop.events = Hop.eventEmitter();

// Utilities
Hop.transitionEnds = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd', 'otransitionend', 'MSTransitionEnd'];
Hop.animationEnds = ['animationend', 'webkitAnimationEnd', 'oanimationend', 'MSAnimationEnd'];
